/**
 * AI Tool Buttons Component
 * Collection of AI assistant buttons (Mix, Chord, Lyric, Drum)
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Brain, Music, Mic, Drum } from 'lucide-react';

export const AIMixAssistantButton = ({ setShowAIMixAssistant }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowAIMixAssistant(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-violet-500/20"
    data-testid="ai-mix-assistant-btn"
    title="AI Mix Assistant"
  >
    <Brain className="w-5 h-5" />
  </Button>
);

export const AIChordGeneratorButton = ({ setShowAIChordGenerator }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowAIChordGenerator(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-purple-500/20"
    data-testid="ai-chord-generator-btn"
    title="AI Chord Generator"
  >
    <Music className="w-5 h-5" />
  </Button>
);

export const AILyricAssistantButton = ({ setShowAILyricAssistant }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowAILyricAssistant(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-pink-500/20"
    data-testid="ai-lyric-assistant-btn"
    title="AI Lyric Assistant"
  >
    <Mic className="w-5 h-5" />
  </Button>
);

export const AIDrumGeneratorButton = ({ setShowAIDrumGenerator }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowAIDrumGenerator(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-orange-500/20"
    data-testid="ai-drum-generator-btn"
    title="AI Drum Pattern Generator"
  >
    <Drum className="w-5 h-5" />
  </Button>
);

export default {
  AIMixAssistantButton,
  AIChordGeneratorButton,
  AILyricAssistantButton,
  AIDrumGeneratorButton,
};
